"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AutocompleteInput = _interopRequireDefault(require("./AutocompleteInput.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var _default2 = exports.default = {
  name: 'AutocompleteSelect',
  components: {
    AutocompleteInput: _AutocompleteInput.default
  },
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: [Array, Number, String, Object, null],
      default: function _default() {
        return [];
      }
    },
    onFetch: {
      type: Function,
      required: true
    },
    selectionProperty: {
      type: String,
      default: 'id'
    },
    labelProperty: {
      type: String,
      default: 'name'
    },
    descriptionProperty: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Adicionar item...'
    },
    multiple: {
      type: Boolean,
      default: true
    },
    showSelectedList: {
      type: Boolean,
      default: true
    }
  },
  emits: ['input'],
  data: function data() {
    return {
      internalSelected: null
    };
  },
  computed: {
    selectedKeys: function selectedKeys() {
      if (this.multiple) {
        return Array.isArray(this.value) ? this.value : [];
      }
      if (this.value === null || this.value === undefined) return [];
      return [this.value];
    },
    selectedItems: function selectedItems() {
      var key = this.selectionProperty;
      var set = new Set(this.selectedKeys);
      return this.items.filter(function (item) {
        return set.has(item[key]);
      });
    }
  },
  methods: {
    getItemLabel: function getItemLabel(item) {
      var _item$this$labelPrope;
      return (_item$this$labelPrope = item === null || item === void 0 ? void 0 : item[this.labelProperty]) !== null && _item$this$labelPrope !== void 0 ? _item$this$labelPrope : '';
    },
    handleSelect: function handleSelect(option) {
      if (!option) return;
      var key = this.selectionProperty;
      var value = option[key];
      if (value === undefined || this.selectedKeys.includes(value)) return;
      if (this.multiple) {
        this.$emit('input', [].concat(_toConsumableArray(this.selectedKeys), [value]));
      } else {
        this.$emit('input', value);
      }
      this.internalSelected = null;
    },
    removeItem: function removeItem(item) {
      var key = this.selectionProperty;
      if (this.multiple) {
        var next = this.selectedKeys.filter(function (v) {
          return v !== item[key];
        });
        this.$emit('input', next);
      } else {
        if (this.value === item[key]) {
          this.$emit('input', null);
        }
      }
    }
  }
};